import { render, staticRenderFns } from "./ProjectDocuments.vue?vue&type=template&id=c1c8f660&scoped=true&"
import script from "./ProjectDocuments.vue?vue&type=script&lang=js&"
export * from "./ProjectDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDocuments.vue?vue&type=style&index=0&id=c1c8f660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c8f660",
  null
  
)

export default component.exports